import { render, staticRenderFns } from "./BlockProducts.vue?vue&type=template&id=330d31cd&"
import script from "./BlockProducts.vue?vue&type=script&lang=js&"
export * from "./BlockProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports